const model = {
    details: null,
    loading: false,
    error: null,
};

export default model;